import type { FaireProductEntity } from "../../entity_types/product";

export const p_ng88c4mkn4: FaireProductEntity = {
  token: "p_ng88c4mkn4",
  type: "product",
  name: "Ass Kickin' Spicy Pickle Popcorn, 12 Count",
  brandName: "Grandpa Joe's Candy Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/9ebd0f035e4c2d826cab126ffdba788a54b94257ad2ed2c75bd30ca2be294fca.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/50a5736cc70cbee8c5a8c2bd1101da50df519e2a105e2740a20cee18465e2b63.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
